import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faDownload } from '@fortawesome/pro-light-svg-icons'

import {
  Box, Button, DashboardModule, StatusBadge, Text,
} from '@domain-group/suit-theme'

import { formatDate } from '@domain-group/javascript-utils'

import useArtwork from '@hooks/useArtwork'
import useArtworkReviews from '@hooks/useArtworkReviews'
import useStatuses from '@hooks/useStatuses'

import { formatEntityCount } from '@functions/entity'

import type { UseOrderItemPayload } from '@hooks/useOrderItem'

interface ActionsProps {
  orderItemPayload: UseOrderItemPayload,
  pageCount: number,
}

const Actions = (props: ActionsProps) => {
  const { orderItemPayload, pageCount } = props

  const {
    artwork,
    orderItem: { artwork_id, dates },
  } = orderItemPayload

  const { filteredStatuses } = useStatuses({ filters: { status_keys: ['approved'] } })
  const approvedStatus = filteredStatuses[0]

  const { filteredArtworkReviews } = useArtworkReviews({ filters: { artwork_id } })
  const artworkReviewIsApproved = filteredArtworkReviews?.some(review => review?.status_id === approvedStatus?.id)

  const { isApproved: artworkIsApproved } = useArtwork(artwork)

  const isApproved = artworkReviewIsApproved || artworkIsApproved

  return (
    <DashboardModule.Footer boxProps={{ flexDirection: ['column', 'row'] }}>
      <Box flexDirection="column" maxWidth={['100%', '50%']}>
        <Box alignItems="center">
          <Text
            color="bodyFontColor"
            fontSize="small"
          >
            Artwork #{artwork_id}
          </Text>

          {isApproved && (
            <StatusBadge
              boxProps={{ marginLeft: 'medium' }}
              color="green"
              ghost
              text={approvedStatus.title}
            />
          )}
        </Box>

        {dates?.updated?.date_time && (
          <Text color="bodyFontLightColor" fontSize="small" marginTop="medium">
            Updated {formatDate(dates?.updated.date_time, 'dd/MM/yyyy HH:mm', "ccc dd LLL 'at' h:mm a")}
          </Text>
        )}
      </Box>

      <DashboardModule.FooterRight
        boxProps={{
          alignItems: ['flexStart', 'center'],
          flexDirection: ['column', 'row'],
          marginTop: ['large', 0],
        }}
      >

        <Text fontSize="small">{formatEntityCount({ entityString: 'Page', entityCount: pageCount })}</Text>

        <Button
          // @ts-expect-error TS2322
          as="a"
          buttonStyle="secondaryUtility"
          href={artwork.links?.download_url}
          icon={<FontAwesomeIcon icon={faDownload} />}
          marginLeft={['none', 'large']}
          marginTop={['medium', 0]}
          size="medium"
          target="_blank"
          width={['100%', 'fit-content']}
        >
          Download PDF
        </Button>
      </DashboardModule.FooterRight>
    </DashboardModule.Footer>
  )
}

export default Actions
